"use strict";

exports.__esModule = true;
exports.AdvancedTimelineValueFields = AdvancedTimelineValueFields;
var _react = _interopRequireDefault(require("react"));
var _AdvancedTimeline = require("../../Timeline/AdvancedTimeline");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function AdvancedTimelineValueFields(props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AdvancedTimeline.AdvancedTimelineSelector, props), /*#__PURE__*/_react["default"].createElement(_AdvancedTimeline.AdvancedTimelineFieldSelector, _extends({}, props, {
    multiple: false,
    showAllFields: true
  })));
}